import {SmartComponentManager} from "../common/smart-component-fix-ie11";
import "../common/custom-event-polyfill";

import DefaultCtrl from "../common/controllers/DefaultCtrl";

import ContactToolComponent from "./components/ContactToolComponent";
import CarouselComponent from "./components/CarouselComponent";
import FormComponent from "./components/FormComponent";
import VideoSectionComponent from "./components/VideoSectionComponent";
import CountdownComponent from "./components/CountdownComponent";
import EventCampusComponent from "./components/EventCampusComponent";

import LandingUtils from "./business/LandingUtils";

import "../../less/marangonilanding/gge-marangonilanding.less";


SmartComponentManager.registerComponents({
    DefaultCtrl,

    ContactToolComponent,
    CarouselComponent,

    FormComponent,
    VideoSectionComponent,
    CountdownComponent,
    EventCampusComponent
});

$(document).ready(() => {
    $('.hero-hp-container script').remove();

    let $body = $('body');

    if ($body.find('.yxpMainContainer').length > 0 && $('.bodySurrogate').length > 0) {
        $body = $('.bodySurrogate');
    }

    $(document).on('keydown', 'input.only-numbers', (e) => {
        if ($(e.originalEvent.target).val().length >= 14 && e.originalEvent.keyCode != 46 && e.originalEvent.keyCode != 8) {
            e.preventDefault();
        } else {
            if (e.originalEvent.keyCode != 46 && e.originalEvent.keyCode != 8) {
                if (!!e.originalEvent.key && !!e.originalEvent.key.match(/[^\d]/g, '')) {
                    e.preventDefault();
                }
            }
        }
    });

    $('html, body').on('scroll', () => {
        manageScroll();
    });

    window.addEventListener("scroll", function () {
        manageScroll();
    }, false);

    manageScroll();

    if (!!$body && !$body.attr('component')) {
        $body.attr("component", 'DefaultCtrl');
    }

    if (!!$body && !!$body.attr('component')) {
        SmartComponentManager.initComponentByName($body[0], $body.attr('component'));
    }

    spaceBottomForCta(true);

    window.addEventListener('resize', spaceBottomForCta);
    document.addEventListener('form-gone', spaceBottomForCta);
});

function manageScroll() {
    $('body').toggleClass('scrolled', $('html, body').scrollTop() > 100);
}

function spaceBottomForCta(force) {
    if (document.spaceBottomTimeout) {
        clearTimeout(document.spaceBottomTimeout);
    }

    // 2. Impostiamo la vera logica dentro il setTimeout
    document.spaceBottomTimeout = setTimeout(function () {
        const ctaElement = document.querySelector('.simple-header .cta');
        if (ctaElement && LandingUtils.isMobile()) {
            document.body.style.paddingBottom = ctaElement.offsetHeight + 'px';
        } else {
            document.body.style.paddingBottom = '';
        }
    }, force ? 0 : 250);
}